import { Component,OnInit } from '@angular/core';
import { NotificationService } from "../../services/notification.service";
import { TenantDetailsRemoverService } from "./tenant-details-remover.service";
import {TenantRetrieverService} from "../../services/tenant-Retriever.service";

@Component({
    selector: 'tenant-details-remover',
    template: require('./tenant-details-remover.component.html'),
})
export class TenantDetailsRemoverComponent implements OnInit {
    tenantName: string;
    tenantNameList: string[];
    isTenantRetrieved: boolean=false;
    responseData: any;
    errorInFetchingTenantNames:boolean = true;
    constructor(private notifier: NotificationService,
        private tenantRemover: TenantDetailsRemoverService, private tenantRetriever: TenantRetrieverService)
    {
        this.notifier.clear();      
    }

    ngOnInit(): void {
         this.getTenantNames();
    }

    getTenantNames() {
        this.notifier.displayInfo("Fetching Tenant Names ...");
        this.tenantRetriever.getTenant().subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.processGetTenantResponse();
            },
            error => {
                this.notifier.displayApiResponseError(error);
            }
        );
    }

    processGetTenantResponse() {

        if (this.responseData.statusCode === 200) {
            this.tenantNameList = this.responseData.data;
            this.tenantName = this.tenantNameList[0];
            this.errorInFetchingTenantNames = false;
        } else {
            this.errorInFetchingTenantNames = true;
            this.notifier.displayError("Unable to fetch Tenant names");
        }
    }

    deleteTenantDetails() {
        this.isTenantRetrieved = true;
        this.notifier.displayInfo("Trying to delete tenant entry..");
        this.tenantRemover.deleteTenantEntry(this.tenantName).subscribe(
            resp => {
                this.notifier.clear();
                this.responseData = resp;
                this.notifier.displaySuccess("Successfully deleted the tenant entry");
            },
            error => {
                this.notifier.clear();
                this.notifier.displayApiResponseError(error);
            });
    }

  
}


/** WEBPACK FOOTER **
 ** ./app/main/tenant-details-remover/tenant-details-remover.component.ts
 **/